
$(".mega-menu-aden").on("click", "a", function(){
  if($(this).parent().parent("details").hasClass("open")){
    $(".mega-menu-aden").removeProp("open")
    $(this).parent(".header__menu-item").attr("aria-expanded", "true")
    $(this).prop("open", "")
  }else{
    $(".mega-menu-aden").removeClass("open");
    $(".mega-menu-aden").find(".header__menu-item").attr("aria-expanded", "false")
    $(".mega-menu-aden").removeProp("open")
    $(this).parent(".header__menu-item").attr("aria-expanded", "true")
    $(this).prop("open", "")   
    $(this).parent("summary").parent("details").addClass("open")
  } 
})


if($("body").hasClass("halo")){
  $("#Details-HeaderMenu-1").removeClass("open")
  $("#Details-HeaderMenu-1").removeAttr("open") 
  $("#Details-HeaderMenu-2").addClass("open")
  $("#Details-HeaderMenu-2").attr("open", "")
}else{   
//NOWT  
}

var docWidth = window.innerWidth;
if(docWidth <= 991){
  
	    $( ".accordionize").accordion({
          disabled: false,
      	  collapsible: true,
		  active: false,			
	     });
}


//ACCORDION
widthMatch = window.matchMedia("(max-width: 990px)");
widthMatch.addEventListener('change', function(mm) {
    if (mm.matches) {   	  
		  $( ".accordionize").accordion({
          disabled: false,
      	  collapsible: true,
		  active: false,			
	     });	   	   
    }
    else {	
		$( ".accordionize").accordion({
        disabled: true,
      	collapsible: false,
		active: true,			
	  });	      
      $(".accordionize .ui-accordion-content").css({"display": "block", "height" : "auto"});
    }
});


if($(".thumbnail-list" ).length > 0){
    function disableButton(){     
      clearTimeout($.data(this, 'scrollTimer'));
      $.data(this, 'scrollTimer', setTimeout(function() {      
      var ulWidth = $(".thumbnail-list").outerWidth()
      var uloffsetLeft = $(".thumbnail-list").offset().left
      var uloffsetRight = $(".thumbnail-list").offset().left + ulWidth
      var slide = $(".thumbnail-list__item:visible")
      var liCount = $(".thumbnail-list__item:visible").length-1
      var firstSlide = slide.eq(0)
      var lastSlide = slide.eq(10)      
      var firstSlideOffsetLeft = slide.eq(0).offset().left
      var lastSlideOffsetRight = slide.eq(liCount).offset().left  
      if(firstSlideOffsetLeft >= uloffsetLeft ){
          $(".slider-button--prev").prop('disabled', 'disabled')  
      }else{
        $(".slider-button--prev").prop("disabled", false)
      }
      if(lastSlideOffsetRight <= uloffsetRight ){
          $(".slider-button--next").prop('disabled', 'disabled')  
      }else{
        $(".slider-button--next").prop("disabled", false)
      }      
        }, 250));       
    }
  
    disableButton()    
    $(".imageSwatch").on("click", function(){
      disableButton() 
    })  
    $( ".thumbnail-list" ).on( "scroll", function() {
      disableButton()    
    })
}

if($(".video-bg").length > 0){
  function resizeVid(meth){
    var winWidth = $("html").outerWidth();
      var vidHeight = $(".banner").not(".invisible").find(".video-bg").outerHeight();
      if(winWidth < 1300){
        $(".banner").not(".invisible").css("min-height", vidHeight+"px")
        $(".banner").not(".invisible").find(".banner__content").css("min-height", vidHeight+"px")
        $(".banner").not(".invisible").find(".banner__content").css("padding-bottom", "0")
      }else{
        $(".banner").not(".invisible").css("min-height", "")
        $(".banner").not(".invisible").find(".banner__content").css("min-height", "") 
        $(".banner").not(".invisible").find(".banner__content").css("padding-bottom", "")
      }
  }  
  resizeVid("initial ")  
  $(".mega-menu-aden, .header__heading").on("click", "a", function(){
  resizeVid("click ")
  }) 
  $( window ).on( "resize", function() {
    resizeVid("resize ")
  }) 
}
